/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'Customer',dictionary:{"de":{"references":{"person":"Person","organization":"Organisation","responsibleWorkers":"Kundenbetreuer"},"customerId":"Kunden-ID","__getters":{"type":"Art","customerName":"Name","customerAddress":"Adresse","customerIdName":"Kunde","responsibleWorkersString":"Kundenbetreuer"}},"en":{"references":{"person":"Person","organization":"Organization","responsibleWorkers":"Account Manager"},"customerId":"Customer-ID","__getters":{"type":"Type","customerName":"Name","customerAddress":"Address","customerIdName":"Customer","responsibleWorkersString":"Account Manager"}}}})
import { Login } from './Login';
import { Person } from './Person';
import { Organization } from './Organization';
import { Worker } from './Worker';
import _ from 'lodash';

export class Customer extends _BaseModel {
	
	static toString() {
		return 'Customer'
	}
	
	get __getters() {
		const self = this;
		return {
			get type() {
        const organization = _.get(self.references, 'organization');
        const person = _.get(self.references, 'person');
        // eslint-disable-next-line no-undef
        if (organization) return _BaseModel.t('models.Customer.references.organization');
        // eslint-disable-next-line no-undef
        else if (person) return _BaseModel.t('models.Customer.references.person');
        else return '';
    },
			get customerName() {
        const organization = _.get(self.references, 'organization.general.fullName');
        const person = _.get(self.references, 'person.__getters.lastFirstTitleName');
        if (organization) return organization;
        else if (person) return person;
        return '';
    },
			get customerIdName() {
        const organization = _.get(self.references, 'organization.general.fullName');
        const person = _.get(self.references, 'person.__getters.lastFirstTitleName');
        if (organization) return self.customerId + ' - ' + organization;
        else if (person) return self.customerId + ' - ' + person;
        return '';
    },
			get customerAddress() {
        const ref = _.get(self.references, 'organization', _.get(self.references, 'person'));
        if (!ref) return 'N/A';
        let addressString = '';

        if (_.get(ref, 'address.street')) addressString += ref.address.street;
        if (_.get(ref, 'address.zipCode')) addressString += ', ' + ref.address.zipCode;
        if (_.get(ref, 'address.city')) addressString += '-' + ref.address.city;
        if (_.get(ref, 'address.country')) addressString += ', ' + ref.address.country;

        return addressString;
    },
			get addressObject() {
        let address = _.get(self.references, 'organization.address');
        if (!address) address = _.get(self.references, 'person.address');
        return address;
    },
			get contactsObjectArray() {
        const person = _.get(self.references, 'person');
        if (person) return [person];
        return _.get(self.references, 'organization.references.contacts', []);
    },
			get responsibleWorkersString() {
        const workerArray = _.get(self.references, 'responsibleWorkers', []);

        return workerArray
            .map(function (item) {
                return _.get(item, 'references.person.__getters.lastFirstName');
            })
            .sort()
            .join(', ');
    },
		}
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Customer.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Customer', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Customer.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Customer', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Customer.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Customer', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Customer', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Customer', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Customer.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Customer', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Customer'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Customer) || _BaseModel.t('rules.reference', {modelName:'Customer', path:'meta.currentDocument'}) ],
				model: Customer,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Customer', path:'meta.revisions'}) ],
				model: Customer,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	person:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Person'),
				itemText: "__getters.lastFirstName",
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Person) || _BaseModel.t('rules.reference', {modelName:'Customer', path:'references.person'}) ],
				model: Person,
				returnObject: true,
},
    
	},
	
					
	organization:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Organization'),
				itemText: "__getters.name",
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Organization) || _BaseModel.t('rules.reference', {modelName:'Customer', path:'references.organization'}) ],
				model: Organization,
				returnObject: true,
},
    
	},
	
					
	responsibleWorkers:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Worker'),
				itemText: "references.person.__getters.lastFirstName",
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Customer', path:'references.responsibleWorkers'}) ],
				model: Worker,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
				
	customerId:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Customer.customerId'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Customer', path:'customerId'}),(value)=> ( typeof value === 'string' && value.length > 0) || _BaseModel.t('rules.type.string', {modelName:'Customer', path:'customerId'}) ],
},
    
	},
	
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Customer._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, customerId='', _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.customerId=customerId;
		this._id=_id;
	}

	static create(data) {
		return new Customer(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof Customer || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : Customer.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof Customer ? item : Customer.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({person=undefined, organization=undefined, responsibleWorkers=[], }={}){
		this.person= (person instanceof Person || typeof person === 'string' || !person) ? person : Person.create(person);
		this.organization= (organization instanceof Organization || typeof organization === 'string' || !organization) ? organization : Organization.create(organization);
		if(Array.isArray(responsibleWorkers)){
			this.responsibleWorkers=[];
			for(const item of responsibleWorkers){
				if(typeof item === 'string') this.responsibleWorkers.push(item)
				else if(typeof item === 'object')
					this.responsibleWorkers.push(item instanceof Worker ? item : Worker.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.responsibleWorkers=responsibleWorkers;
		}
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}
